<template>
  <v-page page="Reports" :breadcrumb="breadcrumb">
    <Spinner ref="spinner"></Spinner>
    <v-container ma-0 px-3 pt-0 pb-0>
      <v-layout text-xs-center>
        <v-flex mb-0 xs12 mx-2>
          <v-layout justify-center row align-center>
            <v-flex pa-0>
              <div pa-0>
                <!-- HEADER -->
                <v-layout justify-start row align-center mt-3 mb-1>
                  <v-flex align-center>
                    <div
                      v-if="reportTitle !== ''"
                      class="text-xs-left align-center"
                      style="font-size: 20px; font-weight: 600;"
                    >{{reportId}} - {{reportTitle}}</div>
                  </v-flex>
                  <v-flex align-center xs6>
                    <v-layout row>
                      <v-flex xs5 ml-5>
                        <v-layout row>
                          <v-text-field
                            v-model="search"
                            label="Search"
                            single-line
                            hide-details
                            class="align-center mt-0 pt-0"
                            @keyup.enter="filterReports"
                          ></v-text-field>
                          <v-btn @click="filterReports" icon mx-2 class="TierButton my-0 py-0">
                            <v-icon style="font-size:18px">fa-search</v-icon>
                          </v-btn>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex>
                    <v-layout class="buttons" justify-end row align-center>
                      <!-- Buttons -->

                      <a
                        style="text-decoration: none"
                        class="align-center mr-4"
                        @click="paginationUpdated"
                      >REFRESH</a>
                      <v-btn
                        color="success"
                        class="mb-1 mr-0 ml-1"
                        @click="runReport"
                        :disabled="runnable !== true"
                      >RUN</v-btn>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <!-- END HEADER -->

                <!-- SERVICES TABLE -->
                <v-data-table
                  :headers="headers"
                  :items="reportHistory"
                  :item-key="reportHistory.index"
                  :rows-per-page-items="rowsPerPageItems"
                  :pagination.sync="pagination"
                  :loading="loading"
                  :total-items="pagination.totalRecords"
                  @update:pagination="paginationUpdated"
                  hide-details
                  class="striped-table no-pagination-btn"
                >
                  <template slot="items" slot-scope="props">
                    <tr :key="props.index">
                      <td class="text-xs-left px-0">
                        <text-highlight
                          :queries="searchHighlight"
                        >{{ props.item["SubmissionDate"] | formatDateTime }}</text-highlight>
                      </td>
                      <td class="text-xs-left px-0">
                        <text-highlight
                          :queries="searchHighlight"
                        >{{ props.item["SubmittedBy"] != null? props.item["SubmittedBy"]: "SYSTEM" }}</text-highlight>
                      </td>
                      <td class="text-xs-left px-0">
                        <div v-if="(props.item.StatusId=='A4')||(props.item.Output != null)">
                          <text-highlight :queries="searchHighlight">{{ props.item["Output"] }}</text-highlight>
                        </div>

                        <div
                          v-if="(props.item.StatusId !='A4')&&(props.item.Output == null)"
                          :class="[{'green--text':props.item.StatusId=='A4'},{'purple--text':props.item.StatusId=='A0'},{'red--text':props.item.StatusId=='A1'} ]"
                        >{{ props.item["Status"] }}</div>
                      </td>
                      <!-- <td class="text-xs-left px-0">{{ props.item["SubmitBy"] }}</td>
                      <td class="text-xs-left px-0">{{ props.item["LastSubmitDate"] }}</td>-->
                      <td class="justify-end align-center text-xs-right pr-0 pt-0 pb-0">
                        <v-layout>
                          <v-flex
                            xs9
                            v-if="(props.item.ReportId) && (props.item.ReportInstanceId) && (props.item.StatusId !== 'A4')"
                          >
                            <v-progress-linear
                              :indeterminate="true"
                              class="align-center fill-height my-2"
                            ></v-progress-linear>
                          </v-flex>
                          <v-flex
                            xs3
                            v-if="(props.item.ReportInstanceId) && (props.item.StatusId != 'A4')"
                          >
                            <a
                              class="ml-0 align-center"
                              style="text-decoration: none"
                              @click="cancelReport(props.item)"
                            >CANCEL</a>
                          </v-flex>
                          <v-flex
                            v-if="(props.item.ReportId) && (props.item.ReportInstanceId) && (props.item.StatusId == 'A4')"
                          >
                            <router-link
                              v-show="(props.item.ReportId) && (props.item.ReportInstanceId) && (props.item.StatusId == 'A4')"
                              class="mr-3"
                              style="text-decoration: none"
                              :to="openViewReport(props.item)"
                            >VIEW</router-link>
                            <a
                              v-show="(props.item.ReportId) && (props.item.ReportInstanceId) && (props.item.StatusId == 'A4')"
                              class="mr-3"
                              style="text-decoration: none"
                              @click="exportToExcel(props.item)"
                            >EXCEL</a>
                            <a
                              v-show="(props.item.ReportId) && (props.item.ReportInstanceId) && (props.item.StatusId == 'A4')"
                              class="ml-0"
                              style="text-decoration: none"
                              @click="exportToCSV(props.item)"
                            >CSV</a>
                          </v-flex>
                          <!-- <a class="mr-0"
                        v-if="props.item.StatusId == 'A2'"
                          style="text-decoration: none"
                          @click="openServiceAuditLogs(props.item)">
                          View
                          </a>-->
                        </v-layout>
                      </td>
                    </tr>
                  </template>
                  <template slot="actions-append">
                  <data-table-pagination :rowsPerPage="pagination.rowsPerPage" :totalRecords="pagination.totalRecords" v-model="pagination.page" @input="paginationUpdated()"></data-table-pagination>
                  </template>
                  <v-alert
                    slot="no-results"
                    :value="true"
                    color="red lighten-3"
                    icon="fa-exclamation-triangle"
                  >
                    Your
                    search for "{{ search }}" found no results.
                  </v-alert>
                  <template slot="no-data">
                    <v-layout row justify-start align-center>
                      <v-flex xs2 style="font-size: 14px;">
                        <span v-show="hasFilter">No records found for the applied filters</span>
                      </v-flex>
                      <v-flex xs8>
                        <v-btn color="primary" @click="initialize">Reset</v-btn>
                      </v-flex>
                    </v-layout>
                  </template>
                </v-data-table>
                <!-- END USERS TABLE -->

                <v-btn
                  color="primary"
                  @click="resetReportHistoryList"
                  v-show="showResetBtn && !loading"
                  style="margin-top: -40px;"
                >Reset</v-btn>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
    <reportRun ref="reportRun"></reportRun>
  </v-page>
</template>

<script>
import VPage from "../../layouts/Default.vue";
import axios from "axios";
import * as helper from "../../helpers/global.js";
import moment from "moment";
import reportRun from "./ReportRun.vue";
import Bus from "../../bus";
import TextHighlight from "vue-text-highlight";
import Spinner from "../../components/Spinner.vue";
import DataTablePagination from "../../components/DataTablePagination.vue";
  import "@/assets/css/main.css"

export default {
  name: "Report History",

  components: {
    VPage,
    reportRun,
    "text-highlight": TextHighlight,
    Spinner,
    DataTablePagination
  },

  data: () => ({
    dialog: false,
    search: "",
    loading: true,

    showResetBtn: false,
    filters: {},
    filtersChanged: false,

    reportHistory: [],
    ddlCategory: [],
    ddlSubmitBy: [],

    reportId: null,
    runnable: false,
    reportTitle: "",
    searchHighlight: "",

    rowsPerPageItems: [
      30,
      45,
      60,
      {
        text: "$vuetify.dataIterator.rowsPerPageAll",
        value: -1
      }
    ],

    // Selected by default
    pagination: {
      rowsPerPage: 30,
      descending: true,
      totalRecords: 0,
      sortBy: "SubmissionDate",
      page: 1
    },

    breadcrumb: [
      {
        text: "Reports",
        disabled: false,
        href: "#/reports"
      },
      {
        text: "All",
        disabled: true,
        href: "#/reports"
      }
    ],

    headers: [
      {
        text: "Submitted",
        value: "SubmissionDate",
        width: "10%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },
      {
        text: "By",
        value: "SubmittedBy",
        // sortable: false,
        width: "10%",
        fixed: true,
        align: "left",
        class:
          "font-weight-bold subheading text-align-right justify-end pr-0 pl-0"
      },

      {
        text: "Output",
        value: "Output",
        // sortable: false,
        width: "10%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading sort-asc"
      },

      {
        text: "Actions",
        value: "actions",
        sortable: false,
        width: "10%",
        fixed: true,
        align: "right",
        class: "font-weight-bold subheading text-align-right justify-end pr-0"
      }
    ]
  }),

  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  filters: {
    formatDateTime: function(date) {
      if (
        moment(date, "YYYY-MM-DDTHH:mm:ss", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.S", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SS", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SSS", true).isValid()
      ) {
        return moment(date, "YYYY-MM-DDTHH:mm:ss").format(
          "YYYY/MM/DD h:mm:ss A"
        );
      }
    }
  },

  computed: {
    hasFilter() {
      let result = false;

      Object.keys(this.filters).forEach(filter => {
        if (this.filters[`${filter}`]) {
          result = true;
        }
      });

      return result;
    }
  },

  created() {
    this.initialize();
    this.$root.$on("initialize", this.initialize);
  },
  mounted() {
    this.interval = setInterval(this.paginationUpdated, 15000);
  },

  beforeDestroy() {
    clearInterval(this.interval);
  },

  destroyed() {
    this.$root.$off("initialize", this.initialize);
  },

  methods: {
    async initialize() {
      this.reportId = this.$route.params.ReportId;

      if (this.reportId !== "all") {
        this.filters = {
          ReportId: this.reportId
        };

        this.filtersChanged = true;

        this.breadcrumb[1].text = this.reportId;
        this.showResetBtn = false;
      } else {
        this.breadcrumb[1].text = "all";
        this.filters = {};
        this.filtersChanged = true;
        this.showResetBtn = false;
      }
      //inits drop down filter lists
      this.getReportInfo();

      if (this.$route.query.search != null){
        this.search = this.$route.query.search;
        this.searchHighlight = this.$route.query.search;
    }

      await this.paginationUpdated();

      this.loading = false;
    },

    // Get list of dropdown options
    getDropdownOptions(url, obj) {
      axios
        .get(url)
        .then(resp => (this[`${obj}`] = resp.data[`${obj}`]))
        .catch(err => console.log(err));
    },
    getReportInfo() {
      var reportId = this.reportId;
      if (
        reportId == "all" ||
        typeof reportId == "undefined" ||
        reportId == null
      ) {
        //do nothing
      } else {
        axios.get("/api/Report/GetReportInfo/" + reportId).then(res => {
          this.runnable = res.data.runnable;
          this.reportTitle = res.data.title;
        });
      }
    },
    async resetReportHistoryList() {
      this.loading = true;
      var reportId = this.reportId;
      this.$router.push("/report-history/" + reportId);

      this.filters = {
        ReportId: this.reportId
      };
      this.filtersChanged = true;
      this.searchHighlight = "";
      this.search = "";
      this.breadcrumb[1].text = reportId;

      await this.paginationUpdated();

      this.showResetBtn = false;
      this.loading = false;
    },

    async filterReports() {
      this.filtersChanged = true;
      this.showResetBtn = true;
      this.searchHighlight = this.search;
      this.updateSearchQuery()
      await this.paginationUpdated();
    },

    async paginationUpdated() {
      this.loading = true;
      await axios
        .post(
          "/api/Report/GetPagedReportHistoryList/",
          {
            postData: {
              pagination: this.pagination,
              filtersChanged: this.filtersChanged,
              filters: this.filters,
              search: this.search
            }
          },
          {
            headers: {
              "Content-type": "application/json"
            }
          }
        )
        .then(response => {
          this.reportHistory = response.data.reportHistory;
          this.pagination.totalRecords = response.data.pagination.totalRecords;
        });
      this.loading = false;
      this.filtersChanged = false;
    },
    openViewReport(item) {
      return "/report-view/" + item.ReportId + "/" + item.ReportInstanceId;
    },
    async runReport() {
      var reportId = this.reportId;
      if (
        reportId == "all" ||
        typeof reportId == "undefined" ||
        reportId == null
      ) {
        //do nothing
      } else {
        await axios
          .get("/api/Report/getReportParameters/" + reportId)
          .then(res => {
            var autorun = res.data.autorun;
            if (autorun == true) {
              this.$refs.reportRun.open({
                autorun: autorun,
                reportId: reportId,
                reportParameters: null,
                reportName: this.reportTitle
              });
            } else if (autorun == false) {
              var reportParameters = res.data.runReportFormParameters;

              this.$refs.reportRun.open({
                autorun: autorun,
                reportId: reportId,
                reportParameters: reportParameters,
                reportName: this.reportTitle
              });
            }
          });
      }
    },
    cancelReport(item) {
      var confirmCancel = confirm(
        "Are you sure you would like to cancel the submitted report?"
      );
      if (confirmCancel == true) {
        var reportInstanceId = item.ReportInstanceId;

        axios.post("/api/Report/cancelReport/" + reportInstanceId).then(res => {
          this.paginationUpdated();
        });
      }
    },
    exportToExcel(item) {
      var reportInstanceId = item.ReportInstanceId;
      var reportTitle = this.reportTitle;
      var reportId = this.reportId;
      this.$refs.spinner.spinOn();
      axios({
        url: "/api/Report/ReportToExcel/" + reportInstanceId,
        method: "POST",
        responseType: "blob"
      })
        .then(response => {
          var currentDate = moment().format("YYYYMMDD.HHmm");
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            reportId + " - " + reportTitle + "." + currentDate + ".xlsx"
          ); //or any other extension
          document.body.appendChild(link);
          link.click();
          this.$refs.spinner.spinOff();
        })
        .catch(err => {
          this.$refs.spinner.spinOff();
        });
    },
    exportToCSV(item) {
      var reportInstanceId = item.ReportInstanceId;
      var reportTitle = this.reportTitle;
      var reportId = this.reportId;
      this.$refs.spinner.spinOn();
      axios({
        url: "/api/Report/ReportToCSV/" + reportInstanceId,
        method: "POST",
        responseType: "blob"
      })
        .then(response => {
          var currentDate = moment().format("YYYYMMDD.HHmm");
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            reportId + " - " + reportTitle + "." + currentDate + ".csv"
          ); //or any other extension
          document.body.appendChild(link);
          link.click();
          this.$refs.spinner.spinOff();
        })
        .catch(err => {
          this.$refs.spinner.spinOff();
        });
    },
    updateSearchQuery(){
      var route = Object.assign({}, this.$route)
      var path = route.path
      var query = route.query
      var oldQuery = Object.assign({}, query)
      oldQuery.search=this.search
      this.$router.push({path:path, query:oldQuery})
    }
  }
};
</script>

<style scoped>
table.v-table tbody td,
table.v-table tbody th {
  height: 22px;
  font-size: 14px;
}

table.v-table tbody th {
  background-color: #4caf50;
}

table.v-table tbody tr:not(:last-child) {
  height: 22px;
  font-size: 14px;
}
.TierButton {
  border-color: #4caf50 !important;
  border-width: 1px !important;
  border-style: solid !important;
  color: #4caf50 !important;
  box-shadow: none !important;
  background-color: transparent !important;
}
.TierButton:hover {
  background-color: #4caf50 !important;
  color: white !important;
}
</style>
